import React from "react";
import "./styles.css";
import templatePreview from "../../assets/img/template-preview.png";

function WhatsappInfo() {
  return (
    <div className="whatsapp-info">
      <h1>Al precio del plan, debes agregar los precios de WhatsApp API</h1>
      <p>Si tu cliente te habla, no hay ningún costo, es gratis.</p>
      <img src={templatePreview} alt="template preview" />
    </div>
  );
}

export default WhatsappInfo;
